import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { useNavigate } from "react-router-dom"; // import navigation

export default function CTASection() {
  const navigate = useNavigate(); // init navigate

  return (
    <MKBox position="relative" textAlign="center">
      {/* Top and bottom gradient overlays for soft fade */}
      <MKBox
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="60px"
        zIndex={1}
        sx={{
          background: "linear-gradient(to bottom, rgba(245, 245, 245, 1), rgba(245, 245, 245, 0))",
        }}
      />
      <MKBox
        position="absolute"
        bottom={0}
        left={0}
        width="100%"
        height="60px"
        zIndex={1}
        sx={{
          background: "linear-gradient(to top, rgba(245, 245, 245, 1), rgba(245, 245, 245, 0))",
        }}
      />

      {/* Main CTA content */}
      <MKBox
        py={10}
        px={3}
        sx={{
          background: "linear-gradient(to right, #7da6f7, #c685e2)",
          color: "white",
          position: "relative",
          zIndex: 2,
          borderRadius: "lg",
        }}
      >
        <MKTypography variant="h3" fontWeight="bold" mb={2}>
          Ready to Get Started?
        </MKTypography>

        <MKTypography variant="body1" opacity={0.9} mb={4}>
          Join thousands of users already accelerating their business with our AI-powered tools.
        </MKTypography>

        <MKButton
          variant="gradient"
          color="white"
          size="large"
          onClick={() => navigate("/contact")} //  route on click
        >
          Book a Demo
        </MKButton>
      </MKBox>
    </MKBox>
  );
}
